import Options from 'trunks/vue/share/components/options.js';
import RadioButtonMixin from 'trunks/vue/share/components/fields/radio_button.js';
import FieldMixinForResponse from './mixin.js';
import LogicalRadioButtonMixin from 'trunks/vue/share/mixins/logic_field/radio_button.js';
import OptionsMultipleSelect from 'trunks/vue/admin/components/options_multiple_select.js';

const RadioButtonForResponse = {
  components: {
    'Options': Options,
    'options-select': OptionsMultipleSelect
  },

  mixins: [
    FieldMixinForResponse,
    RadioButtonMixin,
    LogicalRadioButtonMixin
  ],

  template: `
    <Field :field='field'
           v-show='visible'
           :extendClass='[fieldCommonClass, fieldDifferenceClass]'
           :message='errorMsg'>
      <template slot='input'>
        <options-select v-if="optionsClass === 'select'"
                        :options='field.options'
                        :initSelectedOption='initSelectedOption'
                        :otherOption='otherOption'
                        @valueChange='valueChange'
                        ref='optionsSelectRef' />
        <div v-else class="form-field-value" :class="{ 'readonly': !editing }">
          <Options :initialSelectedOptions='value'
                   :options='field.options'
                   :multiple=false
                   :otherOption='otherOption'
                   :disabled='!editing'
                   :optionsClass='optionsClass'
                   ref='optionsView'
                   @valueChange='valueChange' />
        </div>
      </template>
    </Field>
  `,

  computed: {
    optionsClass: function() {
      return this.field.settings.layout;
    },

    initSelectedOption: function() {
      if (this.entries[0]?.value) {
        return _.find(this.field.options, (item) => item.value === this.entries[0].value);
      } else {
        return null;
      }
    }
  },

  methods: {
    _updateChildView: function() {
      this.$nextTick(function() {
        this.$refs.optionsSelectRef?.reset();
        this.$refs.optionsView?.reset();
      });
    }
  }
};

export default RadioButtonForResponse;
